import {
    COLLECTION_MAPPING,
    PRIORITY_COLLECTIONS,
} from '../constants/collectionMapping';
import { CollectionContentShape } from '../types';

export interface FilterCollections {
    tld: string;
    collections?: CollectionContentShape[];
    collectionBlockList?: string[];
    renderCollectionsWithZeroEvents?: boolean;
}

/**
 * Utility that filters Collections returned for
 * the current location by tld, content, and sorts
 * in priority order as defined by `PRIORITY_COLLECTIONS` in constants.
 *
 * This logic currently isn't supported by the API so we
 * have lifted to the client.
 *
 * @param FilterCollections
 * @returns
 */
export const filterCollections = ({
    tld,
    collections = [],
    collectionBlockList = [],
    renderCollectionsWithZeroEvents = false,
}: FilterCollections) => {
    if (!tld || !collections) {
        return [];
    }

    let filteredCollections = collections;

    const correctTldCollections: any = (COLLECTION_MAPPING as any)[tld]
        ? Object.values((COLLECTION_MAPPING as any)[tld])
        : null;

    if (correctTldCollections) {
        filteredCollections = collections.filter((collection) => {
            // filter out the collection if it has 0 events
            if (!renderCollectionsWithZeroEvents && !collection.eventCount) {
                return false;
            }

            // if the collection's `id` is in correctTldCollections will return truthy and so keep the value
            return (
                correctTldCollections.includes(collection.id) &&
                !collectionBlockList.includes(collection.id)
            );
        });

        // Sorts the collections in case any of them have priority over the others
        let orderedCollections: CollectionContentShape[] = [];
        PRIORITY_COLLECTIONS.forEach((key) => {
            for (const collection of filteredCollections) {
                if (key === collection.id) {
                    orderedCollections.push(collection);
                    break;
                }
            }
        });

        filteredCollections = filteredCollections.filter((collection) => {
            return !PRIORITY_COLLECTIONS.includes(collection.id || '');
        });

        orderedCollections = [...orderedCollections, ...filteredCollections];

        return orderedCollections;
    }

    return [];
};
